<template>
<div class="chapter">
<div class="inner_page">
<p class="centera"><em>Author’s note</em></p>
<p class="para">The events in this book take place in and near Glasgow sometime in the 1990s.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm04.vue?bcd71f92